import React from "react";
import { Modal } from "react-bootstrap";
import TradingViewChart from "../Common/TradingViewChart";

const LiveChartModal = ({ show, onHide, symbol, data }) => {
  const parts = symbol ? symbol.split(" ") : [];
  const name = data?.name || parts[0] || "";
  const segment = data?.segment || data?.exchange || parts[parts.length - 1] || "";
  const expiry = data?.expiry || (parts.length >= 3 ? parts[1] : null);
  const strike = data?.strike || (parts.length === 5 ? parts[2] : null);
  const optionType = data?.optionType || (parts.length === 5 ? parts[3] : null);

  const isExpirySegment = 
    segment && (
      segment.includes("FUT") || 
      segment.includes("OPT") || 
      segment.includes("NFO") || 
      segment.includes("MCX") ||
      segment.includes("COMEX") ||
      segment.includes("CDS")
    );

  let displayName = name;
  if (isExpirySegment) {
    if (expiry && expiry !== "NO-EXPIRY") {
      displayName += ` ${expiry}`;
    }
    if (strike && optionType) {
      displayName += ` ${strike} ${optionType}`;
    }
  }

  const isIndian = segment && (segment.includes("NSE") || segment.includes("NFO") || segment.includes("MCX"));
  const isOption = segment && (segment.includes("OPT") || (strike && optionType));

  return (
    <Modal show={show} onHide={onHide} size="xl" centered contentClassName="bg-black border-secondary">
      <Modal.Header closeButton closeVariant="white" className="border-secondary">
        <Modal.Title className="text-white d-flex flex-column gap-1">
          <div className="d-flex align-items-center gap-3">
            <span>{displayName}</span>
            <small className="text-secondary fw-normal fs-6">{data?.name || name}</small>
            <span className="badge bg-secondary-subtle text-secondary-emphasis fs-xs">{segment}</span>
            <span className="badge bg-primary-focus text-primary-600 fs-xs">TradingView</span>
          </div>
          {isIndian && (
            <div className="d-flex flex-column gap-1 mt-2">
              <div className="text-warning fs-xs fw-normal d-flex align-items-center gap-1">
                <span className="badge bg-warning text-dark px-1 py-0 fs-xxs">VISUALIZATION FALLBACK</span>
                <span>Using {segment?.includes("MCX") ? "Global Standard" : "BSE"} chart for analysis. Actual trade is on {segment?.includes("MCX") ? "MCX" : "NSE"}.</span>
              </div>
              {isOption && (
                <div className="text-danger fs-xs fw-bold d-flex align-items-center gap-1">
                  <span className="badge bg-danger text-white px-1 py-0 fs-xxs">PRICE MISMATCH</span>
                  <span>Currently viewing Underlaying EQUITY chart. This will NOT match the Option price in your watchlist.</span>
                </div>
              )}
            </div>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0" style={{ height: "600px" }}>
        <TradingViewChart symbol={symbol} data={data} />
      </Modal.Body>
    </Modal>
  );
};

export default LiveChartModal;
